import { useState, useEffect } from 'react';

export default function useStickyContent(
    ref,
    isTop,
    offset,
    compareRef,
    compareOtherRef
) {
    const [lastHeight, setLastHeight] = useState(0);

    const [styles, setStyles] = useState({});

    const handleScroll = () => {
        if (!ref.current) {
            return;
        }
        if (window.innerWidth >= 992) {
            const { height } = ref.current.getBoundingClientRect();
            if (lastHeight !== height) {
                let positionStyle = {
                    position: 'sticky',
                    top: `${offset}px`,
                };
                if (!isTop) {
                    if (
                        compareRef &&
                        compareOtherRef &&
                        height >
                            Math.max(
                                compareRef.current.getBoundingClientRect()
                                    .height,
                                compareOtherRef.current.getBoundingClientRect()
                                    .height
                            )
                    ) {
                        positionStyle = { paddingBottom: `${offset}px` };
                    } else {
                        const contentHeight = window.innerHeight;
                        const max = height - contentHeight + offset;
                        positionStyle.top = `-${max}px`;
                    }
                }
                setStyles(positionStyle);
                setLastHeight(height);
            }
        } else {
            setStyles({});
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
        window.addEventListener('resize', handleScroll);
    }, []);

    return [styles];
}
